import { Component, Prop, Vue } from 'vue-property-decorator'
import ConfigurationRelationships
    from '@/modules/configurationModule/shared/components/configuration-relationships/configuration-relationships.vue'
import { ConfigurationPersonnelResponse } from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel/configuration-personnel.dto'
import {
    ConfigurationAutomationPersonnelEntitiesAssociationModalNumberAssignmentFormState,
    initialConfigurationAutomationPersonnelEntitiesAssociationModalNumberAssignmentFormState
} from '@/modules/configurationModule/detail/automation/personnel/entities-association/components/modal-number-assignment-form/configuration-automation-personnel-entities-association-modal-number-assignment-form.model'
import {
    ConfigurationPersonnelNumberAssignmentCreateRequest,
    ConfigurationPersonnelNumberAssignmentResponse
} from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-number-assignment/configuration-personnel-number-assignment.dto'
import { configurationPersonnelNumberAssignmentService } from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-number-assignment/configuration-personnel-number-assignment.service'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { EnumResponse } from '@/api/services/common.dto'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'
import { GridUtils } from '@/shared/util/grid-utils'

@Component({
    components: {
        ConfigurationRelationships
    }
})
export default class ConfigurationAutomationPersonnelEntitiesAssociationModalNumberAssignmentForm extends Vue {
    @Prop(String) readonly actionTitle!: string
    @Prop() readonly personnel!: ConfigurationPersonnelResponse

    state: ConfigurationAutomationPersonnelEntitiesAssociationModalNumberAssignmentFormState
    constructor() {
        super()
        this.state = initialConfigurationAutomationPersonnelEntitiesAssociationModalNumberAssignmentFormState()
    }

    private async _loadPersonnelNumberAssignments(): Promise<void> {
        this.state.personnelNumberAssignments = await this._getPersonnelNumberAssignments()
    }

    async mounted() {
        await this._loadPersonnelNumberAssignments()
    }

    getPersonnelNumberAssignment(personnelNumberAssignment: ConfigurationPersonnelNumberAssignmentResponse): number {
        return personnelNumberAssignment.number
    }

    /// SERVICES CALLS ///

    private async _getPersonnelNumberAssignments(): Promise<ConfigurationPersonnelNumberAssignmentResponse[]> {
        const filterModel: CommonFilterModel = {
            'personnel.id': GridUtils.getNumberFilterModel('equals', this.personnel.id)
        }
        const params: CommonParams = {
            size: PAGINATOR_BIG_PAGE_SIZE
        }
        const response = await this.$_toCallUnique(configurationPersonnelNumberAssignmentService.paginator(filterModel, params, this.state.laboratoryId))
        if (response) {
            return response.content
        }
        return []
    }

    private async _createPersonnelNumberAssignment(createRequest: ConfigurationPersonnelNumberAssignmentCreateRequest): Promise<ConfigurationPersonnelNumberAssignmentResponse | null> {
        const response = await this.$_toCallUnique(configurationPersonnelNumberAssignmentService.create(this.state.laboratoryId, createRequest))
        if (response) {
            this.$_showToastSuccess(this.$tc('configuration.toastMessages.created'))
            return response
        }
        return null
    }

    private async _deletePersonnelNumberAssignment(personnelNumberAssignmentId: number): Promise<void> {
        if (personnelNumberAssignmentId) {
            await this.$_toCallUnique(configurationPersonnelNumberAssignmentService.delete(personnelNumberAssignmentId, this.state.laboratoryId))
            this.$_showToastSuccess(this.$tc('configuration.toastMessages.deleted'))
        }
    }

    /// FORM OPERATIONS ///

    async createOperation(numberEnum: EnumResponse): Promise<void> {
        if (numberEnum) {
            const createRequest: ConfigurationPersonnelNumberAssignmentCreateRequest = {
                personnelId: this.personnel.id,
                number: +numberEnum.code
            }
            if (await this._createPersonnelNumberAssignment(createRequest)) {
                await this._loadPersonnelNumberAssignments()
            }
        }
    }

    async deleteOperation(personnelNumberAssignment: ConfigurationPersonnelNumberAssignmentResponse): Promise<void> {
        if (personnelNumberAssignment) {
            await this._deletePersonnelNumberAssignment(personnelNumberAssignment.id)
            await this._loadPersonnelNumberAssignments()
        }
    }
}
